export const CURRENCY_CODE = {
  AU: 8,
  NZ: 106,
};

export const MAX_CURRENCY_LENGTH = 11;
